import _styled from "@emotion/styled/base";
export const Badge = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1l4kuf60"
} : {
  target: "e1l4kuf60",
  label: "Badge"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhZGdlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNnQyIsImZpbGUiOiJCYWRnZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmV4cG9ydCBjb25zdCBCYWRnZSA9IHN0eWxlZC5kaXYgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1CYWRnZS5qcy5tYXAiXX0= */");